import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../config/api';
import MainHeader from '../../components/MainHeader';
import Footer from '../../components/Footer';
import './MainScreens.css';

export default function RedeemScreen() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [options, setOptions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [amount, setAmount] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState('');
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  const isPremium = user?.is_premium || ['active', 'trialing'].includes(user?.subscription_status);

  useEffect(() => {
    loadOptions();
    loadHistory();
  }, []);

  async function loadOptions() {
    try {
      const { data } = await api.get('/cashback/redeem/options');
      setOptions(data.options || []);
      setBalance(data.balance || 0);
    } catch (err) {
      console.error('Failed to load redeem options:', err);
    } finally {
      setLoading(false);
    }
  }

  async function loadHistory() {
    try {
      const { data } = await api.get('/cashback/redeem/history');
      setHistory(data.redemptions || []);
    } catch { /* ignore */ }
  }

  async function handleRedeem() {
    if (!selectedOption) return;
    
    const amountCents = Math.round(parseFloat(amount) * 100);
    if (isNaN(amountCents) || amountCents <= 0) {
      setError('Please enter a valid amount');
      return;
    }

    if (amountCents > balance) {
      setError('Amount exceeds your available balance');
      return;
    }

    if (amountCents < selectedOption.minimum_cents) {
      setError(`Minimum for ${selectedOption.name} is $${(selectedOption.minimum_cents / 100).toFixed(2)}`);
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const { data } = await api.post('/cashback/redeem', {
        option_id: selectedOption.id,
        amount_cents: amountCents,
        email: email || user?.email,
      });

      setSuccess(data);
      setBalance(data.new_balance);
      setSelectedOption(null);
      setAmount('');
      loadHistory();
    } catch (err) {
      setError(err.response?.data?.error || 'Redemption failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  if (!isPremium) {
    return (
      <div className="main-screen">
        <MainHeader title="Cash Out" showBack={true} backPath="/rewards" />
        <main className="screen-main">
          <div style={{ padding: '40px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>💎</div>
            <h2 style={{ marginBottom: '12px', color: '#fff' }}>Premium Feature</h2>
            <p style={{ color: '#aaa', marginBottom: '24px', lineHeight: '1.6' }}>
              Cashback and redemptions are available exclusively for Premium members.
              Earn $1 back on every verified order!
            </p>
            <button
              onClick={() => navigate('/subscription')}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                border: 'none',
                padding: '14px 32px',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              Upgrade to Premium
            </button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="main-screen">
        <MainHeader title="Cash Out" showBack={true} backPath="/rewards" />
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading cashout options...</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="main-screen">
        <MainHeader title="Cash Out" showBack={true} backPath="/rewards" />
        <main className="screen-main">
          <div style={{ padding: '40px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>
              {success.status === 'completed' ? '✅' : '⏳'}
            </div>
            <h2 style={{ marginBottom: '12px', color: '#fff', fontSize: '22px' }}>
              {success.status === 'completed' ? 'Redemption Complete!' : 'Processing Your Reward'}
            </h2>
            <p style={{ color: '#ccc', marginBottom: '24px', lineHeight: '1.6', fontSize: '15px' }}>
              {success.message}
            </p>
            <div style={{ 
              background: '#1a1a2e', 
              padding: '16px', 
              borderRadius: '12px', 
              marginBottom: '24px',
              border: '1px solid #333'
            }}>
              <div style={{ color: '#aaa', fontSize: '13px', marginBottom: '4px' }}>Remaining Balance</div>
              <div style={{ color: '#06C167', fontSize: '28px', fontWeight: '700' }}>
                ${(balance / 100).toFixed(2)}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={() => setSuccess(null)}
                style={{
                  background: '#333',
                  color: '#fff',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '10px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Redeem More
              </button>
              <button
                onClick={() => navigate('/rewards')}
                style={{
                  background: 'linear-gradient(135deg, #06C167, #4CAF50)',
                  color: '#fff',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '10px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Back to Rewards
              </button>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="main-screen">
      <MainHeader title="Cash Out" showBack={true} backPath="/rewards" />

      <main className="screen-main">
        <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>

          {/* Balance Card */}
          <div style={{
            background: 'linear-gradient(135deg, #06C167 0%, #4CAF50 100%)',
            padding: '24px',
            borderRadius: '16px',
            marginBottom: '24px',
            textAlign: 'center',
            color: '#fff',
          }}>
            <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: '4px' }}>Available Balance</div>
            <div style={{ fontSize: '36px', fontWeight: '800' }}>${(balance / 100).toFixed(2)}</div>
            <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '4px' }}>
              Earn $1 cashback on every verified order
            </div>
          </div>

          {/* Redemption Options */}
          {!selectedOption ? (
            <>
              <h3 style={{ color: '#fff', fontSize: '18px', marginBottom: '16px', fontWeight: '700' }}>
                Choose How to Cash Out
              </h3>

              {options.map(opt => (
                <button
                  key={opt.id}
                  onClick={() => {
                    if (!opt.coming_soon) {
                      setSelectedOption(opt);
                      setAmount((Math.min(balance, opt.minimum_cents) / 100).toFixed(2));
                      setEmail(user?.email || '');
                    }
                  }}
                  disabled={!opt.available && !opt.coming_soon}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    padding: '16px',
                    marginBottom: '10px',
                    background: opt.coming_soon ? '#1a1a2e' : '#1e1e3a',
                    border: opt.available && !opt.coming_soon ? '1px solid #333' : '1px solid #222',
                    borderRadius: '12px',
                    cursor: opt.coming_soon ? 'not-allowed' : opt.available ? 'pointer' : 'not-allowed',
                    opacity: opt.available || opt.coming_soon ? 1 : 0.5,
                    textAlign: 'left',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <span style={{ fontSize: '28px' }}>{opt.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: '#fff', fontWeight: '600', fontSize: '15px', marginBottom: '2px' }}>
                      {opt.name}
                      {opt.coming_soon && (
                        <span style={{
                          background: '#FFD43B',
                          color: '#000',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: '700',
                          marginLeft: '8px',
                          verticalAlign: 'middle',
                        }}>
                          COMING SOON
                        </span>
                      )}
                    </div>
                    <div style={{ color: '#aaa', fontSize: '13px' }}>{opt.description}</div>
                    <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
                      <span style={{ color: '#888', fontSize: '11px' }}>
                        Min: ${(opt.minimum_cents / 100).toFixed(2)}
                      </span>
                      <span style={{ color: '#888', fontSize: '11px' }}>
                        {opt.fee_percent > 0 ? `${opt.fee_percent}% fee` : 'No fees'}
                      </span>
                      <span style={{ color: '#888', fontSize: '11px' }}>
                        {opt.estimated_delivery}
                      </span>
                    </div>
                  </div>
                  {!opt.coming_soon && opt.available && (
                    <span style={{ color: '#06C167', fontSize: '20px' }}>→</span>
                  )}
                </button>
              ))}

              {/* History Toggle */}
              {history.length > 0 && (
                <button
                  onClick={() => setShowHistory(!showHistory)}
                  style={{
                    width: '100%',
                    padding: '14px',
                    marginTop: '16px',
                    background: 'transparent',
                    border: '1px solid #333',
                    borderRadius: '10px',
                    color: '#aaa',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                >
                  {showHistory ? '▼' : '▶'} Redemption History ({history.length})
                </button>
              )}

              {showHistory && history.length > 0 && (
                <div style={{ marginTop: '12px' }}>
                  {history.map(r => (
                    <div key={r.id} style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '12px 14px',
                      marginBottom: '8px',
                      background: '#1a1a2e',
                      borderRadius: '8px',
                      border: '1px solid #222',
                    }}>
                      <div>
                        <div style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>
                          {(r.option_id || '').replace(/_/g, ' ')}
                        </div>
                        <div style={{ color: '#888', fontSize: '12px' }}>
                          {new Date(r.created_at).toLocaleDateString()}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ color: '#FF6347', fontSize: '14px', fontWeight: '600' }}>
                          -${((r.amount_cents || 0) / 100).toFixed(2)}
                        </div>
                        <div style={{
                          fontSize: '11px',
                          fontWeight: '600',
                          color: r.status === 'completed' ? '#06C167' : r.status === 'queued' ? '#FFD43B' : '#888',
                        }}>
                          {r.status === 'completed' ? 'Sent' : r.status === 'queued' ? 'Processing' : r.status}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            /* Redemption Form */
            <div>
              <button
                onClick={() => { setSelectedOption(null); setError(''); }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#aaa',
                  fontSize: '14px',
                  cursor: 'pointer',
                  marginBottom: '16px',
                  padding: '0',
                }}
              >
                ← Back to options
              </button>

              <div style={{
                background: '#1e1e3a',
                padding: '20px',
                borderRadius: '14px',
                border: '1px solid #333',
                marginBottom: '20px',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                  <span style={{ fontSize: '32px' }}>{selectedOption.icon}</span>
                  <div>
                    <div style={{ color: '#fff', fontWeight: '700', fontSize: '17px' }}>{selectedOption.name}</div>
                    <div style={{ color: '#aaa', fontSize: '13px' }}>{selectedOption.estimated_delivery}</div>
                  </div>
                </div>

                {/* Amount Input */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ color: '#aaa', fontSize: '13px', display: 'block', marginBottom: '6px' }}>
                    Amount to redeem
                  </label>
                  <div style={{ position: 'relative' }}>
                    <span style={{
                      position: 'absolute',
                      left: '14px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#fff',
                      fontSize: '18px',
                      fontWeight: '700',
                    }}>$</span>
                    <input
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      min={(selectedOption.minimum_cents / 100).toFixed(2)}
                      max={(balance / 100).toFixed(2)}
                      step="0.01"
                      style={{
                        width: '100%',
                        padding: '14px 14px 14px 30px',
                        background: '#0d0d1a',
                        border: '1px solid #444',
                        borderRadius: '10px',
                        color: '#fff',
                        fontSize: '18px',
                        fontWeight: '700',
                        outline: 'none',
                      }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                    <span style={{ color: '#888', fontSize: '12px' }}>
                      Min: ${(selectedOption.minimum_cents / 100).toFixed(2)}
                    </span>
                    <button
                      onClick={() => setAmount((balance / 100).toFixed(2))}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#06C167',
                        fontSize: '12px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        padding: '0',
                      }}
                    >
                      Use Full Balance (${(balance / 100).toFixed(2)})
                    </button>
                  </div>
                </div>

                {/* Email (for gift cards) */}
                {selectedOption.category === 'gift_card' && (
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ color: '#aaa', fontSize: '13px', display: 'block', marginBottom: '6px' }}>
                      Send gift card to email
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={user?.email || 'your@email.com'}
                      style={{
                        width: '100%',
                        padding: '12px 14px',
                        background: '#0d0d1a',
                        border: '1px solid #444',
                        borderRadius: '10px',
                        color: '#fff',
                        fontSize: '14px',
                        outline: 'none',
                      }}
                    />
                  </div>
                )}

                {/* Fee notice */}
                {selectedOption.fee_percent > 0 && (
                  <div style={{
                    background: '#2a2a3e',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    marginBottom: '16px',
                  }}>
                    <span style={{ color: '#FFD43B', fontSize: '13px' }}>
                      ⚠️ {selectedOption.fee_percent}% processing fee applies
                      {amount && ` (-$${(parseFloat(amount) * selectedOption.fee_percent / 100).toFixed(2)})`}
                    </span>
                  </div>
                )}

                {error && (
                  <div style={{
                    background: '#3a1a1a',
                    border: '1px solid #FF6347',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    marginBottom: '16px',
                    color: '#FF6347',
                    fontSize: '13px',
                  }}>
                    {error}
                  </div>
                )}

                <button
                  onClick={handleRedeem}
                  disabled={submitting}
                  style={{
                    width: '100%',
                    padding: '16px',
                    background: submitting
                      ? '#444'
                      : 'linear-gradient(135deg, #06C167, #4CAF50)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '16px',
                    fontWeight: '700',
                    cursor: submitting ? 'not-allowed' : 'pointer',
                  }}
                >
                  {submitting ? 'Processing...' : `Redeem $${amount || '0.00'}`}
                </button>
              </div>
            </div>
          )}

          {/* Info Section */}
          <div style={{
            background: '#1a1a2e',
            padding: '16px',
            borderRadius: '12px',
            marginTop: '20px',
            border: '1px solid #222',
          }}>
            <h4 style={{ color: '#fff', fontSize: '14px', marginBottom: '8px' }}>How Cashback Works</h4>
            <ul style={{ color: '#aaa', fontSize: '13px', lineHeight: '1.8', paddingLeft: '16px', margin: 0 }}>
              <li>Earn $1 cashback per verified order (up to 10/month)</li>
              <li>Orders verified via receipt/screenshot upload + location</li>
              <li>Gift cards delivered to your email within 24hrs</li>
              <li>Subscription credit applied instantly</li>
              <li>No fees on gift cards or subscription credit</li>
              <li>PayPal & bank transfers coming soon</li>
            </ul>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
